import { ChapterProgress } from './Chapter'
import ChapterResume from './Chapter/ChapterResume'
import MuteButton from './Controls/MuteButton'
import SettingsButton from './Settings/SettingsButton'

export default function FooterBar() {
  return (
    <div className={'bg-black sticky bottom-0 left-0 right-0 z-50 pointer-events-none'}>
      <div
        className={
          'container mx-auto flex items-center justify-between h-[66px] md:h-[100px] px-6 !md:px-0 pointer-events-auto'
        }
      >
        <div>
          <div className={'flex space-x-2'}>
            <SettingsButton />

            <MuteButton />
          </div>
        </div>

        <div>
          <ChapterProgress />
        </div>

        <div>
          <ChapterResume />
        </div>
      </div>
    </div>
  )
}
